import React from 'react';
import PropTypes from 'prop-types';

import { useSettings } from '@atlas/core';
import { Loader } from '@atlas/ui';

export const LayoutLoader = ({ children }) => {
  const { lang } = useSettings();

  if (!lang) {
    return <Loader className="layout-loader" height={60} width={60} />;
  }

  return children;
};

LayoutLoader.propTypes = {
  children: PropTypes.node,
};
